<script setup>

import {onMounted, ref} from "vue";
import ToolTip from "@/components/parts/ToolTip.vue";


const props = defineProps(['elementMap'])

let explanation = ref("");
let element = ref("");

onMounted(() => {
  explanation.value = props.elementMap.explanation;
  // Force text presentation (U+FE0E) on arrow glyphs — without it, iOS/WebKit
  // sometimes falls back to Apple Color Emoji for these characters.
  element.value = props.elementMap.element.replace(/[→↔]/g, '$&︎');
});

let isTooltipVisible = ref(false);
let tooltipPosition = ref({x: 0, y: 0});


const showTooltip = () => {
  isTooltipVisible.value = true;
};

const hideTooltip = () => {
  isTooltipVisible.value = false;
};

const onKeydown = (event) => {
  if (event.key === 'Escape') hideTooltip();
};

const updateTooltipPosition = (event) => {
  tooltipPosition.value = {x: event.clientX - 50, y: event.clientY + 30}; // Adjust the offset as needed
};

</script>

<template>
  <div style="display: inline">
    <span v-if="explanation === ' ' || explanation === ','">
      <span>{{ element }}</span>
    </span>
  <span v-else
        tabindex="0"
        @mouseenter="showTooltip"
        @mouseleave="hideTooltip"
        @mousemove="updateTooltipPosition"
        @focus="showTooltip"
        @blur="hideTooltip"
        @keydown="onKeydown"
        :aria-label="explanation"
      >
      <span class="hover-text" aria-hidden="true">{{ element + ' ' }}</span>
    </span>
  <tool-tip :position="tooltipPosition" :text="explanation" :visible="isTooltipVisible"/>
  </div>
</template>

<style scoped>
.hover-text {
  cursor: pointer;
}

.hover-text:hover {
  color: #999;
}
</style>
